var __assign =
    (this && this.__assign) ||
    function () {
        __assign =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i]
                    for (const p in s) {
                        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
                    }
                }
                return t
            }
        return __assign.apply(this, arguments)
    }
const __createBinding =
    (this && this.__createBinding) ||
    (Object.create
        ? function (o, m, k, k2) {
              if (k2 === undefined) k2 = k
              Object.defineProperty(o, k2, {
                  enumerable: true,
                  get: function () {
                      return m[k]
                  }
              })
          }
        : function (o, m, k, k2) {
              if (k2 === undefined) k2 = k
              o[k2] = m[k]
          })
const __setModuleDefault =
    (this && this.__setModuleDefault) ||
    (Object.create
        ? function (o, v) {
              Object.defineProperty(o, 'default', { enumerable: true, value: v })
          }
        : function (o, v) {
              o.default = v
          })
const __importStar =
    (this && this.__importStar) ||
    function (mod) {
        if (mod && mod.__esModule) return mod
        const result = {}
        if (mod != null) {
            for (const k in mod) {
                if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k)) {
                    __createBinding(result, mod, k)
                }
            }
        }
        __setModuleDefault(result, mod)
        return result
    }
const __importDefault =
    (this && this.__importDefault) ||
    function (mod) {
        return mod && mod.__esModule ? mod : { default: mod }
    }
Object.defineProperty(exports, '__esModule', { value: true })
const lodash_debounce_1 = __importDefault(require('lodash.debounce'))
const React = __importStar(require('react'))
const react_swipeable_1 = require('react-swipeable')
const react_transition_group_1 = require('react-transition-group')
const useEscButton_1 = __importDefault(require('./lib/hooks/useEscButton'))
const usePreventScroll_1 = __importDefault(require('./lib/hooks/usePreventScroll'))
const styles_1 = require('./lib/styles')
const useGlobalStyles_1 = __importDefault(require('./lib/hooks/useGlobalStyles'))
const SlideUpTransition = function (_a) {
    const isVisible = _a.isVisible
    const children = _a.children
    const onClose = _a.onClose
    const _b = _a.unmountOnExit
    const unmountOnExit = _b === void 0 ? true : _b
    const _c = _a.mountOnEnter
    const mountOnEnter = _c === void 0 ? true : _c
    const _d = _a.duration
    const duration = _d === void 0 ? 250 : _d
    const _e = _a.hideScrollbars
    const hideScrollbars = _e === void 0 ? false : _e
    const classNames = useGlobalStyles_1.default(duration, hideScrollbars)
    const nodeRef = React.useRef(null)
    // Actions to close
    useEscButton_1.default(onClose, isVisible)
    usePreventScroll_1.default(isVisible, classNames.contentWrapper)
    // Swiping down interaction
    const _f = React.useState(0)
    const currentDeltaY = _f[0]
    const setDeltaY = _f[1]
    const swipeHandlers = react_swipeable_1.useSwipeable({
        onSwipedDown: lodash_debounce_1.default(
            function (_a) {
                const velocity = _a.velocity
                setDeltaY(0)
                if (velocity > 0.5) {
                    onClose()
                }
            },
            500,
            { leading: true }
        ),
        onSwiping: function (_a) {
            const deltaY = _a.deltaY
            setDeltaY(deltaY)
        }
    })
    const getTransforms = function () {
        if (currentDeltaY >= 0) {
            return undefined
        }
        return {
            transform: 'translate3d(0, ' + currentDeltaY * -1 + 'px, 0)',
            transition: 'none'
        }
    }
    // DektopLayout
    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            react_transition_group_1.Transition,
            {
                appear: true,
                in: isVisible,
                timeout: { appear: 0, enter: 0, exit: duration },
                unmountOnExit: unmountOnExit,
                mountOnEnter: mountOnEnter,
                nodeRef: nodeRef
            },
            function (state) {
                return React.createElement(
                    'div',
                    { ref: nodeRef },
                    React.createElement('div', {
                        onClick: onClose,
                        className: classNames.backdrop,
                        style: styles_1.BackdropStyles[state]
                    }),
                    React.createElement(
                        'div',
                        {
                            className: classNames.drawer,
                            style: __assign(
                                __assign({}, styles_1.TransitionStyles[state]),
                                getTransforms()
                            )
                        },
                        React.createElement(
                            'div',
                            __assign({}, swipeHandlers, {
                                className: classNames.handleWrapper
                            }),
                            React.createElement('div', { className: classNames.handle })
                        ),
                        React.createElement(
                            'div',
                            { className: classNames.contentWrapper },
                            children
                        )
                    )
                )
            }
        )
    )
}
exports.default = SlideUpTransition
